<template>
	<div style="width: 70%; min-width: 400px; padding-top:30px">
		<div v-if="showFilters" style="margin-bottom: 5px; width: 100%">
			<el-select
				v-model="filters"
				multiple
				filterable
				clearable
				:placeholder="$t('select-filters')"
				style="width: 100%"
			>
				<el-option-group v-for="group in options" :key="group.label" :label="group.label">
					<el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-option-group>
			</el-select>
		</div>

		<el-autocomplete
			style="width: 100%"
			clearable
			class="browse-home-input"
			v-model="docsSearch"
			:fetch-suggestions="querySearch"
			:placeholder="$t('search')"
			:trigger-on-focus="false"
			@select="handleSelect"
			@keyup.enter.native="keyup"
			@clear="clear"
		>
			<template slot-scope="{ item }">
				<div class="value" v-if="item.type != 'disabled'">
					<span>
						<md-icon>{{ item.type == "folder" ? "folder" : "description" }}</md-icon>
						{{ item.value }} </span
					><br />
					<span style="font-size:small; color:grey;">{{ item.description }}</span>
				</div>
				<div class="value" v-else>
					<i>{{ $t(item.value) }}</i>
				</div>
			</template>
		</el-autocomplete>

		<div class="show-filters" @click="collapse">
			{{ showFilters ? $t("hide-filters") : $t("show-filters") }}
			<md-icon>{{ showFilters ? "expand_less" : "expand_more" }}</md-icon>
		</div>
	</div>
</template>

<script>
import axios from "axios"

export default {
	name: "search",
	props: ["loadDocs", "loadFolders", "folderID", "from"],
	data() {
		return {
			docsSearch: "",
			showFilters: false,
			filters: [],
			options: []
		}
	},
	watch: {
		from() {
			this.docsSearch = ""
			this.filters = []
			this.showFilters = false
		}
	},
	created() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/tags/", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				let options = []
				res.data.tags.forEach(tag => {
					options.push({ value: "tag_" + tag.id, label: tag.name })
				})
				this.options.push({ label: this.$t("tags"), options: options })
			})
			.catch(err => console.error(err))

		axios
			.get(process.env.VUE_APP_API_URL + "/api/areas/", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				let options = []
				res.data.areas.forEach(area => {
					options.push({ value: "area_" + area.id, label: area.name })
				})
				this.options.push({ label: this.$t("areas"), options: options })
			})
			.catch(err => console.error(err))
	},
	methods: {
		async querySearch(queryString, cb) {
			let tags = []
			let areas = []
			this.filters.forEach(f => {
				let a = f.split("_")
				if (a[0] == "tag") tags.push(a[1])
				else areas.push(a[1])
			})

			const payload = {
				search: queryString.toLowerCase(),
				folder_id: this.folderID,
				pagination: {},
				filters: {
					areas: areas,
					tags: tags
				}
			}
			let flowcharts = []
			let folders = []

			if (this.loadDocs)
				flowcharts = await axios
					.post(`${process.env.VUE_APP_API_URL}/api/flowchart/quickSearch`, payload, {
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					})
					.then(res => {
						if (res.data.items)
							return res.data.items.map(doc => {
								return {
									id: doc.id,
									value: doc.title,
									type: "flowchart",
									description: this.getSubtext(doc.areas, doc.tags)
								}
							})
						return []
					})
					.catch(err => {
						return []
					})

			if (this.loadFolders)
				folders = await axios
					.post(`${process.env.VUE_APP_API_URL}/api/folders/quickSearch`, payload, {
						headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
					})
					.then(res => {
						if (res.data.items)
							return res.data.items.map(folder => {
								return {
									id: folder.id,
									value: folder.name,
									type: "folder",
									description: this.getSubtext(folder.areas, folder.tags)
								}
							})
						return []
					})
					.catch(err => {
						return []
					})

			let concat = folders.concat(flowcharts)
			if (concat.length == 0) concat.push({ id: 0, value: "empty-result", type: "disabled" })
			cb(concat)
		},
		handleSelect(item) {
			if (item.type == "disabled") {
				this.docsSearch = ""
				return
			} else if (item.type == "folder") this.$emit("folderSelected", item)
			else this.$emit("docSelected", item)
		},
		keyup() {
			this.$emit("keyup", this.docsSearch)
		},
		clear() {
			this.$emit("keyup", "")
		},
		getSubtext(item_areas, item_tags) {
			let areas = []
			let tags = []
			item_areas.forEach(area => {
				areas.push(area.area.name)
			})
			item_tags.forEach(tag => {
				tags.push(tag.tag.name)
			})
			let a = areas.concat(tags)
			return a.join(", ")
		},
		collapse() {
			this.showFilters = !this.showFilters

			if (!this.showFilters) this.filters = []
		}
	}
}
</script>

<style scoped>
.show-filters {
	font-size: small;
	color: grey;
	font-style: italic;
	text-align: right;
	margin-top: 5px;
}
</style>
